// extracted by mini-css-extract-plugin
export default {"title":"DeviceName_title__BpWAU"};